<template>
  <div id="GeolocationSimulator">
    <v-btn color="black" :loading="isBusy" :disabled="isBusy" @click="onToggleEnabled">
      <span>GPS Simulation: </span>
      <span v-if="isEnabled">On</span>
      <span v-else>Off</span>
    </v-btn>
    &nbsp;
    <v-btn color="black" :disabled="isBusy || ! isEnabled" @click="onTogglePaused">
      <v-icon v-if="!isPaused">mdi-pause</v-icon>
      <v-icon v-else>mdi-play</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  data: () => ({
    points: [],
    isBusy: false, // loading script, fetching geojson etc.
    isPaused: false,
    isEnabled: false,
    pointInterval: null, // for window.setInterval
    currentPointIndex: null, // the point being shown
  }),
  mounted: function() {
    //
  },
  computed: {
    preparedPoints() {
      // Here we add info to points like how long that point is "active" for.
      // E.g. time before our geolocation should emit the next point etc.
      const vm = this;
      let output = [];
      let current_stop = 0;
      let stop_count = Math.ceil(vm.points.length / 10);
      vm.points.forEach((p, index) => {
        let wait = ((index + 1) % stop_count === 0)
          ? 5000
          : 1000;
        let prepared = {
          wait,
          coords: {
            latitude: p[1],
            longitude: p[0],
            speed: vm.getRandomInt(30),
            accuracy: vm.getRandomInt(55),
            heading: 90 + vm.getRandomInt(10),
          }
        };
        output.push(prepared) ;
      });
      return output;
    }
  },
  watch: {
    'isEnabled': function(enabled) {
      const vm = this;
      if (enabled) {
        geolocate.use();
        vm.startRouteSimulation();
        // eslint-disable-next-line
        window.console && console.log("REMINDER: Always enable GPS simulation *before* granting browser permission to avoid odd behaviour.");
      }
      else {
        geolocate.restore();
      }
    }
  },
  methods: {
    onToggleEnabled() {
      const vm = this;
      this.isBusy = true;
      Promise.all([
        this.loadJavascript(),
        this.loadCoords(),
      ])
      .then(all => {
        this.isEnabled = ! this.isEnabled;
      })
      .catch(err => {
        // no change to this.isEnabled
      })
      .finally(() => {
        vm.isBusy = false;
      });
    },
    onTogglePaused() {
      this.isPaused = ! this.isPaused;
    },
    loadJavascript() {
      return new Promise((resolve, reject) => {
        const script_id = 'mock-geolocation-js';
        const exists = document.getElementById(script_id);
        if ( ! exists) {
          const s = document.createElement('script');
          s.setAttribute('id', script_id);
          s.addEventListener('load', function() {
            resolve(true);
          });
          s.addEventListener('error', function(e) {
            reject(e);
          });
          s.setAttribute('src', "https://cdn.jsdelivr.net/npm/mock-geolocation@1.0.11/dist/geolocate.js");
          document.body.appendChild(s);
        }
        else resolve(true);
      });
    },
    loadCoords() {
      const vm = this;
      return new Promise((resolve, reject) => {
        if (vm.points.length > 0) {
          resolve(vm.points);
        }
        else {
          const url = "/geolocation-simulator-route.geojson";
          // const url = "https://api.npoint.io/b9a2171bf69926fa71ba";
          // const url = "https://cors-anywhere.herokuapp.com/https://jsonkeeper.com/b/D53Z";
          // const url = "https://jsonkeeper.com/b/D53Z"; // fails with cors error so needed cors-enywhere proxy URL above
          fetch(url, {
            mode: 'cors',
            headers: {
              // 'origin': window.location.origin,
              'x-requested-with': 'XMLHttpRequest',
            }
          })
            .then(r => {
              return r.json();
            })
            .then(data => {
              vm.points = data.features[0].geometry.coordinates[0];
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    getRandomInt(max) {
      max = max || 1000;
      return Math.floor(Math.random() * Math.floor(max));
    },
    startRouteSimulation() {
      const vm = this;
      const first_send = (vm.currentPointIndex === null);
      let currentPointIndex = vm.currentPointIndex || 0;
      let point = vm.preparedPoints[currentPointIndex];

      let coords = point.coords;
      let wait = first_send ? 0 : point.wait;

      // Clean up the last interval run.
      if (vm.pointInterval) {
        window.clearInterval(vm.pointInterval);
      }

      vm.pointInterval = window.setInterval(function () {

        if (vm.isEnabled && ! vm.isPaused) {

          coords = Object.assign(coords, { timestamp: Date.now() });

          // Fake a big turn on a stop.
          if (wait == 5000) coords.heading = 45;

          if (first_send) {
            geolocate.send(coords);
          }
          else {
            geolocate.change(coords);
          }

          // Progress to next point in list of known points
          // (or reset to the beginning if at last point)
          currentPointIndex++;
          if ( ! vm.points[currentPointIndex]) {
            currentPointIndex = 0;
          }
          vm.currentPointIndex = currentPointIndex;
        }

        // Retrigger this method for next point.
        vm.startRouteSimulation();

      }, wait);
    }
  }
};
</script>

<style scoped>
  @media only screen and (min-width: 600px) {
    #GeolocationSimulator {
      position: fixed;
      z-index: 9999;
      top: 1rem;
      left: 50%;
      width: auto;
    }
  }
</style>